<template>

    <div class="radial_progress_container">
        <radial-progress-bar
            :completed-steps="progress"
            :animateSpeed="500"
            :diameter="diameter"
            :total-steps="totalSteps"
            :startColor="ProgessColor"
            :stopColor="ProgessColor"
            :innerStrokeColor="bgColor"
            :strokeWidth="strokeWidth">

            <span class="radial_number">
             <animated-number :value="progress" :formatValue="formatValue" :duration="500" />
                <span class='percent_mark'>%</span>
            </span>

        </radial-progress-bar>
    </div>

</template>

<script>
import RadialProgressBar from 'vue-radial-progress'
import AnimatedNumber from "animated-number-vue";

export default {
    name: 'sightRadialProgress',
    components: {
        RadialProgressBar,
        AnimatedNumber
    },
    props: {
        diameter: {
            type: Number,
            default: 100
        },
        value: {
            type: Number,
            default: 0
        },
        totalSteps: {
            type: Number,
            default: 100
        },
        ProgessColor: {
            type: String,
            default: '#666fff'
        },
        bgColor: {
            type: String,
            default: '#DCDCDC'
        },
        strokeWidth: {
            type: Number,
            default: 8
        }
    },
    mounted(){
        setTimeout(() => { this.progress = this.value }, 300)
    },
    data(){
        return {
            progress: 0
        }
    },
    methods: {
        formatValue(val){

            return val.toFixed(0)
        }
    }
}


</script>

<style lang="scss" scoped>
.radial_number{
    font-size: 1.75rem;
    font-weight: 700;
    letter-spacing: -1px;
    color: #666fff;
}
</style>
